import {
  type IngredientV2,
  type PeriodicityResponse,
  usePairing,
  type ProductDetailList as Ingredient,
} from '@hungryroot/rest';
import {
  PeriodicityTypes,
  useCustomerPeriodicities,
} from '@hungryroot/rest-hooks';

export const containsNeverItem = (
  ingredients: Pick<Ingredient, 'id'>[] | Pick<IngredientV2, 'id'>[],
  periodicities: PeriodicityResponse[],
  removedIngredients: number[] = []
) => {
  if (!ingredients || !periodicities) {
    return false;
  }

  const osnMap = periodicities.reduce(
    (acc, periodicity) => {
      acc[periodicity.product] = periodicity;
      return acc;
    },
    {} as Record<number, PeriodicityResponse>
  );

  return ingredients.some(({ id }) => {
    return (
      !removedIngredients.includes(id) &&
      osnMap[id]?.periodicity === PeriodicityTypes.NEVER
    );
  });
};

export const useIngredientContainsNeverPeriodicity = (
  id: number,
  options?: {
    enabled: boolean;
    inventory_date?: string;
    origin?: number;
  },
  modifiedIngredients?: Pick<Ingredient, 'id'>[]
) => {
  const { data: periodicityData } = useCustomerPeriodicities();
  const { data } = usePairing(
    {
      id,
      inventory_date: options?.inventory_date,
      origin: options?.origin,
    },
    options
  );

  if (!periodicityData || !data) {
    return false;
  }

  return containsNeverItem(
    modifiedIngredients && modifiedIngredients.length > 0
      ? modifiedIngredients
      : data.ingredients,
    periodicityData.results
  );
};
